import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from 'components/button';
import Heading from 'components/heading';
import Expander from 'components/expander';
import RichText from 'components/rich-text';

const baseThemes = {
  dark: 'dark',
  light: 'light'
};

const colorThemes = {
  _: '',
  green: 'green'
};

const buttonThemes = {
  primary: 'primary',
  secondary: 'secondary'
};

const HousingProjectStatus = ({
  title,
  text,
  link,
  baseTheme,
  colorTheme,
  buttonTheme
}) => {
  return (
    <div
      className={cn('housing-project-status', {
        [`housing-project-status--${baseTheme}`]: baseTheme
      })}
    >
      <div
        className={cn(
          'housing-project-status__content',
          'housing-project-status__content--desktop-only'
        )}
      >
        {title && (
          <Heading
            level={2}
            theme={Heading.themes.h3PortalBold}
            className="housing-project-status__header"
          >
            {title}
          </Heading>
        )}
        <RichText {...text} />
        {link && (
          <div className="housing-project-status__link">
            <Button
              housingProjectBaseTheme={baseTheme}
              housingProjectButtonTheme={buttonTheme}
              housingProjectColorTheme={colorTheme}
              {...link}
            />
          </div>
        )}
      </div>
      <div
        className={cn(
          'housing-project-status__content',
          'housing-project-status__content--mobile-only'
        )}
      >
        <Expander title={title} theme="plusminus" color={baseTheme}>
          <RichText {...text} />
          {link && (
            <div className="housing-project-status__link">
              <Button
                housingProjectBaseTheme={baseTheme}
                housingProjectButtonTheme={buttonTheme}
                housingProjectColorTheme={colorTheme}
                {...link}
              />
            </div>
          )}
        </Expander>
      </div>
    </div>
  );
};

HousingProjectStatus.propTypes = {
  title: PropTypes.string,
  text: PropTypes.exact(RichText.propTypes),
  link: PropTypes.exact(Button.propTypes),
  buttonTheme: PropTypes.oneOf(Object.values(buttonThemes)),
  baseTheme: PropTypes.oneOf(Object.values(baseThemes)),
  colorTheme: PropTypes.oneOf(Object.values(colorThemes))
};

HousingProjectStatus.propTypesMeta = {
  baseTheme: 'exclude',
  colorTheme: 'exclude'
};

export default HousingProjectStatus;
